/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  PostWithdrawalSecrets200,
  PostWithdrawalSecrets400,
  PostWithdrawalSecrets403,
  PostWithdrawalSecretsMutationRequest,
  PostWithdrawalSecretsMutationResponse,
} from '../entities/PostWithdrawalSecrets'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { errorStructSchema } from './errorStructSchema'
import { v1CreateTaxoparkWithdrawalSecretRequestSchema } from './v1/createTaxoparkWithdrawalSecretRequestSchema'
import { v1CreateTaxoparkWithdrawalSecretResponseSchema } from './v1/createTaxoparkWithdrawalSecretResponseSchema'
import { z } from 'zod'

/**
 * @description OK
 */
export const postWithdrawalSecrets200Schema = z.lazy(() => v1CreateTaxoparkWithdrawalSecretResponseSchema) as unknown as ToZod<PostWithdrawalSecrets200>

/**
 * @description Bad Request
 */
export const postWithdrawalSecrets400Schema = z.lazy(() => errorStructSchema) as unknown as ToZod<PostWithdrawalSecrets400>

/**
 * @description Forbidden
 */
export const postWithdrawalSecrets403Schema = z.any() as unknown as ToZod<PostWithdrawalSecrets403>

/**
 * @description Параметры для создания api-ключа вывода средств для таксопарка
 */
export const postWithdrawalSecretsMutationRequestSchema = z.lazy(
  () => v1CreateTaxoparkWithdrawalSecretRequestSchema,
) as unknown as ToZod<PostWithdrawalSecretsMutationRequest>

export const postWithdrawalSecretsMutationResponseSchema = z.lazy(
  () => postWithdrawalSecrets200Schema,
) as unknown as ToZod<PostWithdrawalSecretsMutationResponse>